import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex align-center justify-center",
  style: {"height":"100vh","position":"relative"}
}

import { ref } from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import { auth0Module } from '@/store/entityModules/auth0';


export default /*@__PURE__*/_defineComponent({
  __name: 'SignIn',
  setup(__props) {

const isLoading = ref(true);


return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_progress_circular, {
      indeterminate: "",
      color: "#EE6090",
      size: "50"
    })
  ]))
}
}

})